export default __webpack_public_path__ + "static/media/020-shovel.20dc434e.png";